import { createStore, applyMiddleware } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { getInitialState, rootReducer } from './stores';

export * from './stores';

export const getStore = () => createStore(
	rootReducer,
	getInitialState(),
	composeWithDevTools(applyMiddleware(thunk)),
);
